export const IT_CONSULTATION_URL =
  "https://ultroneous.com/it-consulting-services";
export const IT_CONSULTATION_DESCRIPTION =
  "ultroNeous Technologies is a trusted global IT consulting company & Service Firm, with IT support, managed IT services, & computer support for businesses.";
export const IT_CONSULTATION_TITLE =
  "IT Consulting Support & Services | ultroNeous Technologies";

export const WHAT_EXPECT_IT_CONSULTING_DATA = [
  {
    image: "/assets/services/it-consulting/extensive-analysis.webp",
    alt: "Extensive Analysis",
    title: "Extensive Analysis ",
    description:
      "Our trained experts will deep dive into the project idea and process to provide a detailed IT consultation report for your project, both technology and core architect level wise.",
  },
  {
    image: "/assets/services/it-consulting/process-validations.webp",
    alt: "Process Validations",
    title: "Process Validations",
    description:
      "We will carefully review your project process and strategies, verify it with the latest tools and technology trends as well as make required changes to validate it for a smoother execution.",
  },
  {
    image: "/assets/services/it-consulting/code-standards.webp",
    alt: "Code Standards",
    title: "Code Standards",
    description:
      "Be it a code refactoring or creating the code from scratch, our expert developers would make sure to upgrade a code level with the latest design patterns and code architectures.",
  },
  {
    image: "/assets/services/it-consulting/it-support.webp",
    alt: "100% Support",
    title: "100% Support",
    description:
      "When you select an ultroNeous team as your IT consulting partner or project maintenance team, you can rely on us for the 100% support for the timely responses and execution.",
  },
  {
    image: "/assets/services/it-consulting/flexible-models.webp",
    alt: "Flexible Models",
    title: "Flexible Models",
    description:
      "You tell us your requirements and we will set up the team and business model accordingly. It can be only product maintenance or with maintenance plus new feature development. ",
  },
  {
    image: "/assets/services/it-consulting/suggestions.webp",
    alt: "Suggestions",
    title: "Suggestions",
    description:
      "The ultimate goal is to make our client successful. We are always eager to suggest industry based techniques, processes and ideas to make product development and execution successful.",
  },
];
export const IT_CONSULTATION_SCHEMA = {
  itconsultingBreadcrumb: {
    "@context": "https://schema.org",

    "@type": "BreadcrumbList",

    itemListElement: [
      {
        "@type": "ListItem",

        position: 1,

        item: {
          "@id": "https://ultroneous.com/",

          name: "ultroNeous Technologies",
        },
      },
      {
        "@type": "ListItem",

        position: 2,

        item: {
          "@type": "WebPage",

          "@id": "https://ultroneous.com/services",

          url: "https://ultroneous.com/services",

          name: "services",
        },
      },
      {
        "@type": "ListItem",

        position: 3,

        item: {
          "@type": "WebPage",

          "@id": IT_CONSULTATION_URL,

          url: IT_CONSULTATION_URL,

          name: "IT Consulting Support & Services",
        },
      },
    ],
  },
};
export const PROJECT_MAINTENANCE_DATA = [
  {
    leftNumber: "01",
    leftText: "Study the project <br /> documents",
    rightNumber: "02",
    rightText: "Code setup and<br />study",
  },
  {
    leftNumber: "03",
    leftText: "Project understanding <br /> meeting",
    rightNumber: "04",
    rightText: "Reliable project <br /> development team",
  },
  {
    leftNumber: "05",
    leftText: "Bug fixing",
    rightNumber: "06",
    rightText: "New module <br /> development",
  },
  {
    leftNumber: "07",
    leftText: "Code refactoring",
    rightNumber: "08",
    rightText: "Support & Maintenance",
  },
];
export const STARTED_LIST_DATA = [
  {
    title: "Project architecture audit",
  },
  {
    title: "Code Review & Assessment",
  },
  {
    title: "Third party integration audit",
  },
  {
    title: "Code refactoring",
  },
  {
    title: "UI/ UX audit and changes",
  },
];
export const NEW_PROJECT_DATA  = [
  {
    title: "Ideation & Research",
  },
  {
    title: "Prototyping",
  },
  {
    title: "Selection of Technology Stack",
  },
  {
    title: "Defining Project Architecture",
  },
  {
    title: "Development Roadmap",
  },
  {
    title: "Progress Monitoring",
  },
  {
    title: "Code Review & Assessment",
  },
];
